// Function to determine if a day should be disabled

export const isPastDay = (day: Date): boolean => {
    const today = new Date();

    today.setHours(0, 0, 0, 0); // Remove time component from today's date

    return day < today;
};
